// extracted by mini-css-extract-plugin
export default {"wrapper":"addQuestion_wrapper__i4hRB","text_ansver_box":"addQuestion_text_ansver_box__ECg9z","text_box":"addQuestion_text_box__mVnLZ","imgQuiz":"addQuestion_imgQuiz__vEVtW"};